import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { EncodingUtils } from "../../../../shared/utils/encoding.utils";
import { REDIRECT_REASON } from "../routing/routing.service";
import { Subscription } from "rxjs";
import { TOKEN } from "../auth/token";

const DB_ENTRA_AUTO_LOGIN_STARTED = "dbEntraAutoLoginStarted";

@Component({
    selector: "app-external-redirect",
    template: `
    <div class="d-flex flex-column align-items-center mt-5">
      <div class="spinner-border mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternalRedirectComponent implements OnInit, OnDestroy {
  private _routeParamsSubscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this._routeParamsSubscription = this.route.queryParams.subscribe(
      async (params) => {
        let token = params.token ?? "";

        if (token != "" && typeof Storage !== "undefined") {
          localStorage.setItem(TOKEN, EncodingUtils.encodeBase64(token));
          sessionStorage.removeItem(REDIRECT_REASON);
          sessionStorage.removeItem(DB_ENTRA_AUTO_LOGIN_STARTED);

          this.router.navigateByUrl("/login");
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this._routeParamsSubscription) {
      this._routeParamsSubscription.unsubscribe();
    }
  }
}
